import { configureAppIdentity } from '@flobi/asset-library/app-shell';
import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';
import { HOME_URL } from './homeUrl';
import { Root } from './Root';
import './index.css';
// The Flobi cursor, glowing in this app's accent. After the app's own CSS, so Tailwind has declared its layer order first.
import '@flobi/asset-library/cursor/artwork.css';
import { startGpuAudit } from './lib/dev/gpuAudit';
import apiClient from './services/apiClient';

// Development only: warns about chrome that makes the canvas flash on macOS Chrome.
startGpuAudit();
// The tab's name and icon from the platform's app registry, as every Flobi app shows them
// (`@flobi/asset-library/app-shell`): painted from the last answer at once, asked again
// in the background. The gateway is empty because apiClient already carries its origin.
// "Back to Flobi Home" (the page for a seat refused at the door) goes to this build's own
// Home, as Drive's and Brands' do, not always to production (review H8).
configureAppIdentity({ app: 'artwork', aliases: ['flobi-artwork'], name: 'Artwork', gateway: '', request: apiClient, homeUrl: HOME_URL });

createRoot(document.getElementById('root')!).render(
  <StrictMode>
    <Root />
  </StrictMode>,
);
